import { TargetEntityType } from "@/shared/domain/customFields";
import { type LucideIcon, ENTITY_ICONS } from "@/shared/foundation/icons";

interface EntityTypeTab {
  entityType: TargetEntityType;
  label: string;
  Icon: LucideIcon;
}

// Ordered Devices → Sessions → Events → Collections → Datasets. Icons come
// from ENTITY_ICONS so the cue matches the rest of the app.
export const ENTITY_TYPE_TABS: EntityTypeTab[] = [
  {
    entityType: TargetEntityType.Device,
    label: "Devices",
    Icon: ENTITY_ICONS.device,
  },
  {
    entityType: TargetEntityType.Session,
    label: "Sessions",
    Icon: ENTITY_ICONS.session,
  },
  {
    entityType: TargetEntityType.Event,
    label: "Events",
    Icon: ENTITY_ICONS.event,
  },
  {
    entityType: TargetEntityType.Collection,
    label: "Collections",
    Icon: ENTITY_ICONS.collection,
  },
  {
    entityType: TargetEntityType.Dataset,
    label: "Datasets",
    Icon: ENTITY_ICONS.dataset,
  },
];
